<template>
  <div id="fitbit-sleep-stages">
    <mu-card v-if="fitbitData.sleep.length > 0">

      <mu-divider></mu-divider>

      <mu-row>
        <mu-col width="50" desktop="50" tablet="50" style="border-right: 1px solid #e0e0e0">
          <mu-card-header
            titleClass="largeTitle blackTitle"
            title="Time asleep"
            subTitleClass="timeAsleep"
            :subTitle="normalizeDuration(sleepBreakdown.total)"></mu-card-header>
        </mu-col>
        <mu-col width="50" desktop="50" tablet="50">
          <mu-card-header
            titleClass="largeTitle blackTitle"
            title="Time in bed"
            subTitleClass="timeAsleep"
            :subTitle="normalizeDuration(sleepBreakdown.totalInBed)"></mu-card-header>
        </mu-col>
      </mu-row>
      <mu-divider></mu-divider>
      <mu-card-header titleClass="largeTitle blackTitle" title="Stages of sleep" :subTitle="date"></mu-card-header>
      <mu-divider></mu-divider>
      <div v-if="sleepBreakdown &&  sleepBreakdown.type === 'classic'">
        <mu-row align="center">
          <mu-col class="padding" width="33" desktop="33" tablet="33" style="border-right: 1px solid #e0e0e0">
            <div>
              <strong>Awake</strong>
            </div>
            <div> {{normalizeDuration(sleepBreakdown.minutes.awake)}}</div>
            <div>{{sleepBreakdown.formatted.awake}}%</div>
          </mu-col>
          <mu-col class="padding" width="33" desktop="33" tablet="33" style="border-right: 1px solid #e0e0e0">
            <div><strong>Asleep</strong></div>
            <div>{{normalizeDuration(sleepBreakdown.minutes.asleep)}}</div>
            <div>{{sleepBreakdown.formatted.asleep}}%</div>
          </mu-col>
          <mu-col class="padding" width="33" desktop="33" tablet="33">
            <div><strong>Restless</strong></div>
            <div>{{normalizeDuration(sleepBreakdown.minutes.restless)}}</div>
            <div>{{sleepBreakdown.formatted.restless}}%</div>
          </mu-col>
        </mu-row>
        <mu-divider></mu-divider>
        <mu-card-text style="padding-top:0"> <div class="accreditation">
          <img src="static/integrations/fitbit.svg" style="width: 24px">
          Data from FitBit
        </div></mu-card-text>
      </div>
      <mu-card-text v-if="sleepBreakdown && sleepBreakdown.type === 'stages'">
        <div>
          <div class="rail">
            <div class="percentage-bar awake" v-bind:style="{'width': sleepBreakdown.formatted.wake + '%'}"></div>
            <div class="afterText">
              <div class="bold">{{sleepBreakdown.formatted.wake}}% awake</div>
              <div>{{normalizeDuration(sleepBreakdown.minutes.wake)}}</div>
            </div>
            <div class="clear"></div>
          </div>
          <div class="rail">
            <div class="percentage-bar rem" v-bind:style="{'width': sleepBreakdown.formatted.rem + '%'}"></div>
            <div class="afterText">
              <div class="bold">{{sleepBreakdown.formatted.rem}}% REM</div>
              <div>{{normalizeDuration(sleepBreakdown.minutes.rem)}}</div>
            </div>
            <div class="clear"></div>
          </div>

          <div class="rail">
            <div class="percentage-bar light" v-bind:style="{'width': sleepBreakdown.formatted.light + '%'}"></div>
            <div class="afterText">
              <div class="bold">{{sleepBreakdown.formatted.light}}% light</div>
              <div>{{normalizeDuration(sleepBreakdown.minutes.light)}}</div>
            </div>
            <div class="clear"></div>
          </div>
          <div>
            <div class="percentage-bar deep" v-bind:style="{'width': sleepBreakdown.formatted.deep + '%'}"></div>
            <div class="afterText">
              <div class="bold">{{sleepBreakdown.formatted.deep}}% deep</div>
              <div>{{normalizeDuration(sleepBreakdown.minutes.deep)}}</div>
            </div>
            <div class="clear"></div>
          </div>
        </div>




        <div class="accreditation">
          <img src="static/integrations/fitbit.svg" style="width: 24px">
          Data from FitBit
        </div>


      </mu-card-text>
    </mu-card>
    <mu-card v-if="fitbitData.sleep.length === 0">
      <mu-card-header titleClass="largeTitle blackTitle" title="No data" :subTitle="date"></mu-card-header>
    </mu-card>
  </div>
</template>

<script>
  import MuDivider from "muse-ui/src/divider/divider";
  import MuCardHeader from "muse-ui/src/card/cardHeader";
  import MuCardActions from "muse-ui/src/card/cardActions";

  export default {
    components: {
      MuCardActions,
      MuCardHeader,
      MuDivider
    },
    name: "fitbit-sleep-stages",
    props: {
      date: {
        type: String,
        default: ''
      },
      fitbitData: {
        type: Object,
        default: {}
      }
    },
    mounted() {
      let self = this;

    },
    methods: {
      normalizeDuration(minutes) {
        let hourString;
        let minuteString = 'min';
        if (minutes > 60) {
          let hours = Math.floor(minutes / 60);
          let outputMins = minutes % 60;
          if (hours > 1) {
            hourString = 'hrs'
          }
          else {
            hourString = 'hr';
          }
          if (outputMins > 1) {
            minuteString = 'mins';
          }
          else {
            minuteString = 'min';
          }
          return hours + hourString + ' ' + outputMins + minuteString
        }
        return minutes + ' ' + minuteString
      }
    },
    computed: {
      normalizeDate() {
        let self = this;
      },
      sleepBreakdown() {
        let self = this;
        if (_.has(self.fitbitData.sleep[0], 'levels')) {
          if (_.has(self.fitbitData.sleep[0].levels, 'summary')) {


            if (self.fitbitData.sleep[0].type === 'stages') {
              let deepMinutes = self.fitbitData.sleep[0].levels.summary.deep.minutes;
              let awakeMinutes = self.fitbitData.sleep[0].levels.summary.wake.minutes;
              let lightMinutes = self.fitbitData.sleep[0].levels.summary.light.minutes;
              let remMinutes = self.fitbitData.sleep[0].levels.summary.rem.minutes;
              let totalMinutes = (deepMinutes + awakeMinutes + lightMinutes + remMinutes);
              let totalAsleep = (deepMinutes + lightMinutes + remMinutes);

              let deepPercent = (deepMinutes / totalMinutes * 100);
              let awakePercent = (awakeMinutes / totalMinutes * 100);
              let remPercent = (remMinutes / totalMinutes * 100);
              let lightPercent = (lightMinutes / totalMinutes * 100);

              return {
                type: 'stages',
                totalInBed: totalMinutes,
                total: totalAsleep,
                deep: deepPercent,
                wake: awakePercent,
                rem: remPercent,
                light: lightPercent,
                minutes: {
                  deep: deepMinutes,
                  wake: awakeMinutes,
                  rem: remMinutes,
                  light: lightMinutes
                },
                formatted: {
                  deep: deepPercent.toFixed(1),
                  wake: awakePercent.toFixed(1),
                  rem: remPercent.toFixed(1),
                  light: lightPercent.toFixed(1)
                }
              }
            }

            if (self.fitbitData.sleep[0].type === 'classic') {
              let levels = self.fitbitData.sleep[0].levels.summary;
              let asleepPercent = levels.asleep.minutes / self.fitbitData.summary.totalTimeInBed * 100;
              let awakePercent = levels.awake.minutes / self.fitbitData.summary.totalTimeInBed * 100;
              let restlessPercent = levels.restless.minutes / self.fitbitData.summary.totalTimeInBed * 100;

              return {
                type: 'classic',
                totalInBed: self.fitbitData.summary.totalTimeInBed,
                total: self.fitbitData.summary.totalMinutesAsleep,
                minutes: {
                  asleep: levels.asleep.minutes,
                  awake: levels.awake.minutes,
                  restless: levels.restless.minutes
                },
                formatted: {
                  asleep: asleepPercent.toFixed(1),
                  awake: awakePercent.toFixed(1),
                  restless: restlessPercent.toFixed(1)
                }
              }
            }
          }
        }
        else {
          return false;
        }
      }
    }
  }
</script>
<style lang="less">


  @rem: #003D44;
  @awake: #FF1C47;
  @deep: #00D7F5;
  @light: #00A6BF;

  #fitbit-sleep-stages {

    .mu-card-header-title {
      padding: 0;
    }

    .percentage-bar {
      float: left;
      background: #c9c9c9;
      height: 48px;
      margin-right: 8px;

      &.rem {
        background: @rem;
      }
      &.awake {
        background: @awake;
      }
      &.deep {
        background: @deep
      }
      &.light {
        background: @light;
      }
    }

    .rail {
      margin-bottom: 8px;
    }

    .afterText {
      padding-top: 3px;
    }

    .clear {
      clear: both;
    }

    .bold {
      font-weight: bold;
    }
    .accreditation img {
      margin-top: 8px;
    }

    .accreditation img {
      position: relative;
      top: 7px;
      margin-right: 6px;
      background-color: white;
    }

    .largeTitle {
      font-size: 16px !important;
      color: black
    }

    .mediumTitle {
      font-size: 14px;
      color: black !important;
    }

    .timeAsleep {
      font-size: 24px;
    }

  }

  .col.padding.col-33.tablet-33.desktop-33 {
    padding: 16px;
  }
</style>



// WEBPACK FOOTER //
// FitbitSleepStages.vue?c2159a20